import React from "react";

export const FramingPreview = ({ src, option, className = "" }) => {
  const aspectRatio = `${option.print_width_cm} / ${option.print_height_cm}`;
  const objectPosition = `${(option.crop_x ?? 0.5) * 100}% ${(option.crop_y ?? 0.5) * 100}%`;
  return (
    <div className={`bg-[#1a1410] p-2 shadow-sm ${className}`} data-testid={`framing-preview-${option.code}`}>
      <div className="bg-[#fbf9f4] p-3">
        <div className="overflow-hidden bg-neutral-100" style={{ aspectRatio }}>
          {src ? (
            <img src={src} alt="" className="w-full h-full object-cover" style={{ objectPosition }} draggable={false} />
          ) : (
            <div className="w-full h-full bg-neutral-100" />
          )}
        </div>
      </div>
    </div>
  );
};

export default FramingPreview;
